import { render, staticRenderFns } from "./group-detail-members.vue?vue&type=template&id=46801d92&"
import script from "./group-detail-members.ts?vue&type=script&lang=js&"
export * from "./group-detail-members.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports